import { Service } from '@/types/services';
import { Building2, Home } from 'lucide-react';

export const architectureServices: Service[] = [
  {
    id: 'architectural-services',
    title: 'Architectural Drafting & Visualisation',
    icon: 'Building2',
    shortDescription: 'Remote architectural drafting, layouts and 3D visualisation for residential and commercial projects.',
    description: 'We produce the drawing and visualisation work behind a building project: measured layouts, technical plans and photoreal 3D renderings, delivered remotely to your architect, contractor or developer. This is a drafting and visualisation service — we do not carry out site supervision, construction administration, or submit stamped drawings for permit approval, all of which need an architect licensed in your jurisdiction.',
    offerings: [
      {
        name: 'Architectural Plans & Blueprints',
        description: 'Technical drawings and blueprints prepared to your specification for use by your project team.'
      },
      {
        name: 'Interior/Exterior Layouts',
        description: 'Space planning and layout design for optimal functionality and aesthetics.'
      },
      {
        name: '3D Visuals and Drafting',
        description: 'Realistic 3D renderings and visualizations of architectural designs.'
      },
      {
        name: 'Cost Estimation',
        description: 'Project budgeting and cost analysis, based on the rates and supply market you specify.'
      }
    ],
    benefits: [
      'Optimized space utilization and functionality',
      'Designs that reflect your personal or brand aesthetic',
      'Visualization of the final result before construction',
      'Drawings delivered in the formats your project team already uses'
    ],
    image: 'https://images.unsplash.com/photo-1487958449943-2429e8be8625',
    category: 'architecture'
  }
];
